import Styled from 'styled-components';

const Option = Styled.div`
  position: relative;
  line-height: 40px;
  border-bottom: 1px solid #e8e8e8;
  cursor: pointer;
  display: flex;
  
  &:last-child {
    border-bottom: none;
  }

  > input {
    appearance: none;
    width: 0;
    height: 0;

    &:checked {
      :before {
        content: "";
        position: absolute;
        top: calc(50% - 7px);
        right: 0px;
        margin-right: 8px;
        width: 5px;
        height: 10px;
        border-style: solid;
        border-color: #000;
        border-image: initial;
        border-width: 0px 2px 2px 0px;
        transform: rotate(45deg);
      }
    }
  }

  > label {
    width: 100%;
    height: 100%;
    cursor: pointer;
  }

`;

const Select = Styled.div`
  margin: 0 15px;
`;

export default Select;
export { Select, Option };
